export const throttle = (callback, limit) => {
	let waiting = false
	return function () {
		if (!waiting) {
			callback.apply(this, arguments)
			waiting = true
			setTimeout(function () {
				waiting = false
			}, limit)
		}
	}
}

export const debounce = (func, wait) => {
	let timeout

	return (...args) => {
		const later = () => {
			clearTimeout(timeout)
			func(...args)
		}

		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
	}
}
